import * as Connector from 'shared/connectors/searchConnector';
import { SEARCH } from 'store/types';

const init = () => ({
  type: SEARCH.SEARCH_ITEMS_INIT,
});

export const success = data => ({
  type: SEARCH.SEARCH_ITEMS_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: SEARCH.SEARCH_ITEMS_FAILURE,
});

const searchItems = params => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.searchItems(params);
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default searchItems;
